export const RAY_BAN = 'Ray-Ban'
export const RAY_BAN_LOGO = '/rbstatichtml/assets/images/icons/dark-logo.svg'
export const RB = 'RB'
export const UPS = 'UPS'

export const USD = 'USD'
export const BRL = 'BRL'

export const GIFT_CARD = 'gift-cards'
export const GIFT__CARD = 'GIFT CARD'
export const GIFTCARD = 'GIFTCARD'

export const GIFTCARDS = [GIFT_CARD, GIFT__CARD, GIFTCARD]
